module.exports = "https://www.gc-pro.gnp.com.mx/59de7350e4b5d5ae460bb473a3a56c47.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/boton/01.png
// module id = 1006
// module chunks = 0 1